import api from './api';
import { ConfiguracaoWhiteLabel, DashboardConsultor, EstatisticaCliente } from '../types/models';

class WhiteLabelService {
  
  async obterConfiguracao(): Promise<ConfiguracaoWhiteLabel> {
    const response = await api.get('/api/white-label/configuracao');
    return response.data;
  }

  async atualizarConfiguracao(configuracao: ConfiguracaoWhiteLabel): Promise<ConfiguracaoWhiteLabel> {
    const response = await api.put('/api/white-label/configuracao', configuracao);
    return response.data;
  }

  async obterConfiguracaoPorLink(linkPersonalizado: string): Promise<ConfiguracaoWhiteLabel> {
    const response = await api.get(`/api/white-label/configuracao/link/${linkPersonalizado}`);
    return response.data;
  }

  async obterEstatisticasClientes(): Promise<EstatisticaCliente[]> {
    const response = await api.get('/api/white-label/estatisticas/clientes');
    return response.data;
  }

  async obterDashboardConsultor(): Promise<DashboardConsultor> {
    const response = await api.get('/api/white-label/dashboard');
    return response.data;
  }

  async gerarLinkPersonalizado(): Promise<string> {
    const response = await api.post('/api/white-label/link-personalizado');
    return response.data;
  }

  async validarLinkPersonalizado(link: string): Promise<boolean> {
    try {
      const response = await api.get(`/api/white-label/validar-link/${link}`);
      return response.data.disponivel;
    } catch (error) {
      console.error('Erro ao validar link personalizado:', error);
      return false;
    }
  }

}

export default new WhiteLabelService();